var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.document.data.redirect_enabled)?_c('a',{attrs:{"href":("/out/" + (_vm.document.id) + "/"),"target":"_blank","rel":"nofollow"}},[_c('i',{staticClass:"fa fa-external-link-alt"}),_vm._v(" "+_vm._s(_vm.text)+"\n\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }